/**
 * Algolia InstantSearch with AI Chat Widget
 * 
 * This module initializes the Algolia search with the chat widget.
 * The chat widget requires a packaging system (not available via CDN/UMD).
 * 
 * Note: Custom styling via cssClasses uses Tailwind classes.
 * Additional overrides for Algolia's base styles are in mentor-list-twocol.html.
 */

import { liteClient as algoliasearch } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { chat } from 'instantsearch.js/es/widgets';
import 'instantsearch.css/components/chat.css';

// Chat widget configuration - styling via CSS in mentor-list-twocol.html
const chatConfig = {
    container: '#chat',
    agentId: 'c8b50cd7-b3c3-402e-87ea-01155f879ef5',
    openByDefault: false,
    templates: {
        header: {
            titleText: 'Assistant',
        },
        prompt: {
            textareaPlaceholderText: 'What kind of mentor are you looking for?',
            disclaimerText: 'The assistant uses LLM technology and can make mistakes. Please verify the information.',
        },
        messages: {
            loaderText: 'Thinking...',
        },
    },
};

// Make all links in chat open in new tab
function setupChatLinkHandler(container) {
    const observer = new MutationObserver(() => {
        container.querySelectorAll('.ais-ChatMessage a').forEach(link => {
            if (!link.hasAttribute('target')) {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            }
        });
    });
    observer.observe(container, { childList: true, subtree: true });
}

// Initialize the chat widget when the DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    const chatContainer = document.getElementById('chat');
    
    if (!chatContainer) {
        console.warn('Algolia Chat: #chat container not found');
        return;
    }

    // Check if search is already initialized from the main script
    if (window.search) {
        // Add the chat widget to the existing search instance
        window.search.addWidgets([chat(chatConfig)]);
    } else {
        // Create a standalone search instance for chat-only use cases
        const searchClient = algoliasearch('YD3XA4V91L', '454b55a2e50bc884225318d99b0dad1a');
        
        const chatSearch = instantsearch({
            indexName: 'MentorProfile_prod',
            searchClient,
        });

        chatSearch.addWidgets([chat(chatConfig)]);
        chatSearch.start();
    }

    // Set up link handler for new tab behavior
    setupChatLinkHandler(chatContainer);
});

